
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Navigate } from "react-router-dom";

import './App.css';
import LoginPage from './Component/LoginPage';
import ApplicantDashboard from "./Component/ApplicantDashboard";
import CreateExam from "./Component/ExaminerDashboard";
import CreateQuestion from "./Component/CreateQuestion";
import AllQuestions from "./Component/QuestionBank";
import QuestionBank from "./Component/QuestionBank";
import UserLogin_Page from "./Component/UserLogin_Page";
import ThankYou from "./Component/ThankYou";
import LectureDashboard from "./Component/LectureDashboard";
import CreateQuestionSet from "./Component/CreateQuestionSet";
import ExamDashboard from "./Component/ExaminerDashboard";
import AdminDashboard from "./Component/AdminDashboard";
import ViewQuestionSets from "./Component/ViewQuestionSets";
import ExamQuestionSets from "./Component/ViewQuestionSets";
import ExamPage from "./Component/ExamPage";
import MyQuestions from "./Component/MyQuestions";
import UserSignup_Page from "./Component/UserSignup_Page";
import AssignedStudents from "./Component/AssignedStudents";
import Result from "./Component/Result";



const ApplicantProtectedRoute = ({ children }) => {
  const dashboardData = JSON.parse(localStorage.getItem("dashboardData"));

  // ✅ If not logged in → send to login
  if (!dashboardData) {
    return <Navigate to="/" replace />;
  }

  // ✅ If not approved → block access
  if (dashboardData.status !== "Approved") {
    return <Navigate to="/" replace />;
  }

  // ✅ If no question set assigned → block exam access
  if (!dashboardData.assignedQuestionSet) {
    return <Navigate to="/applicant-dashboard" replace />;
  }

  return children;
};


const StaffProtectedRoute = ({ children, allowedRoles }) => {
  const staffUser =
    JSON.parse(localStorage.getItem("staffData")) ||
    JSON.parse(localStorage.getItem("user"));

  // ❌ NOT LOGGED IN AS STAFF
  if (!staffUser || !staffUser.role) {
    return <Navigate to="/" replace />;
  }

  // ❌ WRONG ROLE
  if (!allowedRoles.includes(staffUser.role)) {
    return <Navigate to="/" replace />;
  }

  return children;
};




function App() {
  return (
      <Router>
      <Routes>
        <Route path="/" element={<LoginPage />} />


        <Route
  path="/applicant-dashboard"
  element={
    <ApplicantProtectedRoute>
      <ApplicantDashboard />
    </ApplicantProtectedRoute>
  }
/>
        {/* <Route path="/applicant-dashboard" element={<ApplicantDashboard/>} /> */}
        <Route path="/create-exam" element={<CreateExam/>} />
        <Route path="/create-question" element={<CreateQuestion/>} />
        <Route path="/question-bank" element={<QuestionBank/>} />
        <Route path="/user-login" element={<UserLogin_Page/>} />
         {/* <Route path="/lecture-dashboard" element={<LectureDashboard/>} /> */}
         <Route
  path="/lecture-dashboard"
  element={
    <StaffProtectedRoute allowedRoles={["lecture", "admin"]}>
      <LectureDashboard />
    </StaffProtectedRoute>
  }
/>
         <Route path="/createquestion-set" element={<CreateQuestionSet/>} />
         {/* <Route path="/examsection-dashboard" element={<ExamDashboard/>} /> */}
         <Route
  path="/examsection-dashboard"
  element={
    <StaffProtectedRoute allowedRoles={["examsection", "admin"]}>
      <ExamDashboard />
    </StaffProtectedRoute>
  }
/>
         <Route path="/admin-dashboard" element={<AdminDashboard/>} />
          <Route path="/view-questionset" element={<ViewQuestionSets/>} />
          <Route path="/my-questions" element={<MyQuestions/>} />
            {/* <Route path="/exam" element={<ExamPage/>} /> */}
            <Route
  path="/exam"
  element={
    <ApplicantProtectedRoute>
      <ExamPage />
    </ApplicantProtectedRoute>
  }
/>



<Route path="/createquestion-set/:questionSetId" element={<CreateQuestionSet />} />
          <Route path="/signup" element={<UserSignup_Page />} />
        <Route path="/assigned-students" element={<AssignedStudents />} />
        <Route path="/result" element={<Result/>} />
          <Route path="/thank-you" element={<ThankYou />} />
          <Route
          path="/exam/:examId/question-sets"
          element={<ExamQuestionSets/>}
        />

      </Routes>
    </Router>
  );
}

export default App;
